<template>
  <div>
    <TopAppBarDrawer></TopAppBarDrawer>
    <router-view></router-view>
    <main class="main-wrapper flex-grow-1">
      <div class="d-flex align-items-center">
        <div
          class="t-headline13 t-color-headlineBlack pda-14 t-center font-m flex-grow-1 fix-header-title d-flex justify-content-center align-items-center"
        >
          <div class="font-m">{{ $t("3590") }}</div>
        </div>
      </div>
      <div class="divider"></div>
      <!-- subtabs -->
      <div class="container container--narrow mgt-50">
        <div class="t-headline11 l-spacing72 t-line-h-27 font-m">
          {{ $t("3591") }}
        </div>

        <!-- 탈퇴 유의사항 세부항목 -->
        <div class="mgt-24">
          <div v-for="(text, i) in withdrawTextList" :key="i">
            <div
              class="t-body1 font-r l-spacing48 t-line-h-26 t-color-bodyGrayA mgt-14"
            >
              {{ text }}
            </div>
          </div>
        </div>

        <!-- 탈퇴 내역 -->
        <div class="mgt-8 list_box mgt-50 pda-16">
          <div
            v-for="(withdrawDetail, i) in withdrawDetailList"
            :key="i"
            class="d-flex flex-column mgb-18 t-body3"
          >
            <div
              class="t-body1 font-r l-spacing48 t-line-h-26 t-color-bodyGrayA"
            >
              {{ withdrawDetail.title }}
            </div>
            <div
              class="t-body1 font-r l-spacing48 t-line-h-26 t-color-headlineBlack"
            >
              {{ withdrawDetail.content }}
            </div>
          </div>

          <div class="t-color-textfieldError t-helper mgt--16">
            {{ $t("3612") }}
          </div>
        </div>

        <!-- 현재 회원 보유 내역 -->
        <div
          v-if="userReward"
          class="pdt-16 pdb-16 mgb-16 bg-documentGray w-full-ignore-parent mgt-50"
        >
          <div
            class="d-flex justify-content-between pdt-14 pdb-14 pdl-16 pdr-16"
          >
            <div class="t-body3 t-color-gray3">{{ $t("3613") }}</div>
            <div>
              {{ userReward.point }}
              <span class="t-helper">{{ $t("3617", { str: "" }) }}</span>
            </div>
          </div>
          <div
            class="d-flex justify-content-between pdt-14 pdb-14 pdl-16 pdr-16"
          >
            <div class="t-body3 t-color-gray3">{{ $t("3614") }}</div>
            <div>
              {{ userReward.certificate }}
              <span class="t-helper">{{ $t("3618", { str: "" }) }}</span>
            </div>
          </div>
          <div
            class="d-flex justify-content-between pdt-14 pdb-14 pdl-16 pdr-16"
          >
            <div class="t-body3 t-color-gray3">{{ $t("3615") }}</div>
            <div>
              {{ userReward.badge }}
              <span class="t-helper">{{ $t("3618", { str: "" }) }}</span>
            </div>
          </div>
        </div>

        <div class="mdc-form-field">
          <div class="mdc-checkbox">
            <input
              id="checkbox-term"
              type="checkbox"
              class="mdc-checkbox__native-control"
              :value="checkTerm"
              @change="handleCheckTerm"
            />
            <div class="mdc-checkbox__background check-red">
              <svg class="mdc-checkbox__checkmark" viewBox="0 0 24 24">
                <path
                  class="mdc-checkbox__checkmark-path"
                  fill="none"
                  d="M1.73,12.91 8.1,19.28 22.79,4.59"
                />
              </svg>
              <div class="mdc-checkbox__mixedmark"></div>
            </div>
          </div>
          <label for="checkbox-term" class="t-body1 pdl-0 t-color-black">
            {{ $t("3619") }}
          </label>
        </div>

        <div class="mgt-30 pdb-50">
          <button
            class="mdc-button mdc-button--raised bg-mainBtn t-color-mainBtnText b-radius4 mgr-8"
            @click="next()"
            @keypress="next()"
            tabindex="0"
          >
            <div class="mdc-button__ripple"></div>
            <span class="mdc-button__label t-body2 font-r font-m">
              {{ $t("3620") }}</span
            >
          </button>
          <button
            class="mdc-button t-color-secondaryBtnText b-radius4 mgr-8"
            @click="handleClose()"
            @keypress="handleClose()"
            tabindex="0"
          >
            <div class="mdc-button__ripple"></div>
            <span class="mdc-button__label t-body2 font-r font-m">
              {{ $t("3621") }}</span
            >
          </button>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
/**
 * 회원 탈퇴 요청 컴포넌트(deactivate account component)
 *
 * @author sohyun.ahn@emcast.com
 */

// Components/Mixin/Extend/API define
import { MDCTextField } from "@material/textfield";
import { MDCRipple } from "@material/ripple";
import TopAppBarDrawer from "@/components/TopAppBarDrawer.vue";
import memberApi from "@/api/memberApi.js";

export default {
  data() {
    return {
      deleteReasonValidIcon: "",
      deleteReason: "",
      reasonTextfield: null,
      withdrawTextList: [
        this.$t("3592"),
        this.$t("3593"),
        this.$t("3594"),
        this.$t("3595"),
        this.$t("3596"),
        this.$t("3597"),
      ],
      withdrawDetailList: [
        {
          title: this.$t("3598"),
          content: this.$t("3599"),
        },
        {
          title: this.$t("3600"),
          content: this.$t("3601"),
        },
        {
          title: this.$t("3602"),
          content: this.$t("3603"),
        },
        {
          title: this.$t("3604"),
          content: this.$t("3605"),
        },
        {
          title: this.$t("3606"),
          content: this.$t("3607"),
        },
        {
          title: this.$t("3608"),
          content: this.$t("3609"),
        },
        {
          title: this.$t("3610"),
          content: this.$t("3611"),
        },
      ],
      userReward: "",
      checkTerm: false,
      deleteReasonValidIcon: "",
      deleteReason: "",
    };
  },

  components: {
    TopAppBarDrawer,
  },

  computed: {
    // 유효성 체크(validation check)
    deleteReasonInvalidCheck() {
      if (this.errors.has("deleteReason")) {
        this.deleteReasonValidIcon = "warning";
        return true;
      } else {
        this.deleteReasonValidIcon = "";
        return false;
      }
    },
  },

  mounted() {
    this.getProfileInfo();
    this.setMaterialUi();
  },

  methods: {
    // 사용자 정보 조회
    async getProfileInfo() {
      try {
        const result = await memberApi.getMemberReward();
        if (result && result.data.data) {
          this.userReward = result.data.data;
        }
      } catch (error) {
        console.log("GET PROFILE INFO ERROR : ", error);
      }
    },

    // 탈퇴 요청(request delete)
    async next() {
      // 체크 확인
      if (!this.checkTerm) {
        return this.$snackOpen({ contents: this.$t("3622") });
      }

      // 환불 상태 확인
      if (this.userReward.refundInProgress > 0) {
        return this.$alert({
          title: this.$t("3623"),
          content: this.$t("3624"),
          accept: this.$t("3625"),
        }).then(() => {
          this.$router.go(-1);
        });
      }

      // 소셜 계정 확인
      try {
        const result = await memberApi.getMemberSocial();
        if (result) {
          this.$router.push({
            name: "WithdrawalConfirm",
            query: {
              ...this.$route.query,
              type: result.data.data.condition ? "SOCIAL" : "PASSWORD",
              socialTypeName: result.data.data.social
                ? result.data.data.social.name
                : "",
              socialTypeId: result.data.data.social
                ? result.data.data.social.id
                : "",
            },
          });
        }
      } catch (error) {
        console.log("GET SOCIAL INFO ERROR : ", error);
      }
    },
    handleClose() {
      this.$router.go(-1);
    },
    handleCheckTerm() {
      this.checkTerm = !this.checkTerm;
    },
    setMaterialUi() {
      this.reasonTextfield = new MDCTextField(
        document.querySelector("#reasonTextfield")
      );
      this.reasonTextfield.useNativeValidation = false;
      window.mdc.autoInit();
      const buttonRipple = [].map.call(
        document.querySelectorAll(".mdc-button"),
        function (el) {
          let button = new MDCRipple.attachTo(el);
          return button;
        }
      );
    },
  },
};
</script>

<style scoped>
.mdc-floating-label {
  top: 24px !important;
}
.mdc-select-control-custom {
  border-radius: 4px;
  padding-top: 10px;
}
</style>